// Eventos de Google Analytics (gtag se carga en public/index.html) y Meta Pixel.
// Las vistas de página las registran GA y el Pixel solos (detectan los cambios de historial de la SPA).
// En desarrollo no se envía nada, solo se loguea, para no ensuciar los datos de producción.

const isDev = process.env.NODE_ENV === 'development';
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

// Nuestros eventos → eventos estándar de Meta (los que usa para optimizar anuncios).
// Los que no están acá se envían como eventos personalizados.
const META_STANDARD_EVENTS = {
  publicacion_creada: 'Lead',
  contactar_vendedor: 'Contact',
  ver_ficha: 'ViewContent',
  busqueda: 'Search',
};

// Snippet oficial de Meta, cargado solo en producción y si hay Pixel ID
function initMetaPixel() {
  if (isDev || !META_PIXEL_ID || window.fbq) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
  document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
}
initMetaPixel();

export function track(event, params = {}) {
  if (isDev) {
    console.debug('📊 [analytics]', event, params);
    return;
  }
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', event, params);
    }
    if (typeof window.fbq === 'function') {
      const standard = META_STANDARD_EVENTS[event];
      if (standard) {
        window.fbq('track', standard, params);
      } else {
        window.fbq('trackCustom', event, params);
      }
    }
  } catch (e) {
    // Un bloqueador o un error de GA/Meta nunca debe romper la página
  }
}

// Parámetros comunes de un vehículo (resultado de búsqueda o ficha)
export function vehicleParams(vehicle) {
  if (!vehicle) return {};
  const propia = !!vehicle.url?.startsWith('/publicar/');
  return {
    vehicle_id: vehicle.id,
    titulo: vehicle.title,
    anio: vehicle.year,
    precio: vehicle.price ? Number(vehicle.price) : undefined,
    ciudad: vehicle.city || undefined,
    proveedor: propia ? 'BuscaTuAuto' : vehicle.providerName,
    propia,
  };
}
